import { actionTypes } from "./actionTypes";

export const Reducer = (state: any, action: any) => {
  switch (action.type) {
    case actionTypes.setAuthUser:
      return {
        ...state,
        authUser: action.payload,
      };
    default:
      return state;
  }
};
